// extracted by mini-css-extract-plugin
export var button = "_cr-7";
export var buttonRow = "_cr-6";
export var fadeIn = "_cr-1";
export var gradient = "_cr-0";
export var panel = "_cr-2";
export var panelIn = "_cr-3";
export var subtitle = "_cr-5";
export var title = "_cr-4";